module.exports = __webpack_public_path__ + "static/media/HYGIENE MONITORING INDICATORS.f888fd3d.svg";